module.exports = __webpack_public_path__ + "img/sequence-kyoto-gojo.e339bb94.jpg";